import React, { useState, useCallback, useRef, useEffect } from 'react';
import { debounce } from 'lodash';
import { Input } from '../../../components/ui/input';

interface DebouncedInputProps {
    placeholder?: string;
    type?: string;
    className?: string;
    initialValue?: string;
    debounceMs?: number;
    onDebouncedChange: (value: string) => void;
}

export const DebouncedInput: React.FC<DebouncedInputProps> = ({
    placeholder,
    type = 'text',
    className,
    initialValue = '',
    debounceMs = 500,
    onDebouncedChange
}) => {
    const [internalValue, setInternalValue] = useState(initialValue);

    const debouncedCallback = useRef(
        debounce((value: string) => {
            onDebouncedChange(value);
        }, debounceMs)
    ).current;

    const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setInternalValue(value);
        debouncedCallback(value);
    }, [debouncedCallback]);

    useEffect(() => {
        return () => {
            debouncedCallback.cancel();
        };
    }, [debouncedCallback]);

    useEffect(() => {
        setInternalValue(initialValue);
    }, [initialValue]);

    return (
        <Input
            type={type}
            placeholder={placeholder}
            value={internalValue}
            onChange={handleChange}
            className={className}
        />
    );
};